module.exports = angular;


//////////////////
// WEBPACK FOOTER
// external "angular"
// module id = 338
// module chunks = 0